var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kaer-page"},[(_vm.showHeader && _vm.computedShow)?_c('kaer-header',{attrs:{"headerConfig":_vm.props.headerConfig,"opacity":_vm.opacity,"customBack":_vm.customBack},on:{"goBack":function($event){return _vm.$emit('goBack')}}}):_vm._e(),_c('div',{staticClass:"kaer-page-container",style:({
      paddingTop: _vm.props.headerConfig && _vm.props.headerConfig.immersion
        ? 0
        : _vm.computedShow
          ? _vm.px2rem(_vm.headerPaddingTop)
          : 0,
      backgroundColor: _vm.props.backgroundColor || undefined,
      backgroundImage: _vm.props.backgroundImage
        ? ("url(" + (_vm.props.backgroundImage) + ")")
        : undefined,
    })},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }